import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Area, ComposedChart, ReferenceLine } from 'recharts';
import { FinanceData } from '../types';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';

interface DynamicsExpenditureProps {
  data: FinanceData[];
}

export const DynamicsExpenditureTable: React.FC<DynamicsExpenditureProps> = ({ data }) => {
  const { t } = useTranslation();
  const chartData = data.flatMap(yearData => 
    yearData.periods.map(period => ({
      месяц: period.periodStart.substring(0, 7), 
      [t('arrived')]: yearData.budgetTotal,
      [t('departed')]: yearData.expensesTotal
    }))
  ).sort((a, b) => a.месяц.localeCompare(b.месяц));

  const separator2023 = chartData.findIndex(item => item.месяц.startsWith('2023'));
  const separator2024 = chartData.findIndex(item => item.месяц.startsWith('2024'));

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t('Dynamics of total revenues and expenditures')}</h2>
      <div className={styles.chartContainer}>
        <ResponsiveContainer>
          <ComposedChart data={chartData}>
            <defs>
              <linearGradient id="colorПрибыло" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="rgba(0, 128, 0, 0.2)" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="rgba(0, 128, 0, 0.1)" stopOpacity={0}/>
              </linearGradient>
              <linearGradient id="colorУбыло" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="rgba(255, 165, 0, 0.2)" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="rgba(255, 165, 0, 0.1)" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false} />
            <XAxis 
              dataKey="месяц" 
              axisLine={false}
              tickFormatter={(value) => {
                const year = value.split('-')[0];
                return year;
              }}
              ticks={chartData.length > 0 ? [
                chartData[0].месяц,
                chartData[Math.floor(chartData.length / 2)].месяц,
                chartData[chartData.length - 1].месяц
              ] : []}
              tick={{
                fontSize: 12,
                fontWeight: 500,
                dy: 10
              }}
            />
            <YAxis 
              axisLine={false} 
              domain={[0, 'auto']}
              ticks={[0, 20000, 40000, 60000, 80000, 100000]}
            />
            <Tooltip
              contentStyle={{
                background: '#fff',
                border: 'none',
                borderRadius: '8px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                padding: '10px'
              }}
            />
            <Legend />
            {separator2023 > -1 && (
              <ReferenceLine x={chartData[separator2023].месяц} stroke="#ccc" strokeWidth={1} />
            )}
            {separator2024 > -1 && (
              <ReferenceLine x={chartData[separator2024].месяц} stroke="#ccc" strokeWidth={1} />
            )}
            <Area
              type="monotone"
              dataKey={t('arrived')}
              fill="url(#colorПрибыло)"
              stroke="green"
              strokeWidth={2}
              dot={{ r: 3, fill: 'green' }}
              activeDot={{ r: 5 }}
            />
            <Area
              type="monotone"
              dataKey={t('departed')}
              fill="url(#colorУбыло)"
              stroke="orange"
              strokeWidth={2}
              dot={{ r: 3, fill: 'orange' }}
              activeDot={{ r: 5 }}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
      <div className={styles.yearLabels}>
        {/* <span>2022</span>
        <span>2023</span>
        <span>2024</span> */}
      </div>
    </div>
  );
};